export default __webpack_public_path__ + "static/section_4_details_6-af8ed1bc4cc6bac0c6a8970a827f3a99.png";